import { render, staticRenderFns } from "./HomeWidget.vue?vue&type=template&id=e25649c4&scoped=true&"
import script from "./HomeWidget.vue?vue&type=script&lang=js&"
export * from "./HomeWidget.vue?vue&type=script&lang=js&"
import style0 from "./HomeWidget.vue?vue&type=style&index=0&id=e25649c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e25649c4",
  null
  
)

export default component.exports